import CascateList from "../../../../../../common/components/cascate_list";

/**
 * Header Empreendimento Lista.
 * 
 */

type Props = {

};

export const Header = ({

}: Props) => {

  // const handleStatusChange = useCallback((e: SelectChangeEvent<number>) => {
  //   onStatusChange(typeof e.target.value === "string" ? parseInt(e.target.value) : e.target.value)
  // }, [onStatusChange]);

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid-flow-row-dense">
            {/* <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
              <div className="w-full">
                <DefaultInput
                  variant="outlined"
                  label="Código"
                  name="search_by_código_centro_custo"
                  value={""}
                  onChangeValue={() => { }} />
              </div>

              <div className="w-full">
                <DefaultInput
                  variant="outlined"
                  label="Nome Centro Custo"
                  name="search_by_nome_centro_custo"
                  value={""}
                  onChangeValue={() => { }} />
              </div>
            </div> */}

          </div>
        </div>
      </CascateList>
    </>
  );
}